import {
  ComparatorContext,
  GraphComparisonApiService,
  GraphLegacyApiService,
  useCurrentStepIndex,
  useField,
  useForm,
} from '@kizi/comparator-core';
import { Button } from '@kizi/core-components';
import React, { useContext } from 'react';
import { scrollToTop } from '../../../utils/global';

export const SubmitCurrentFormButton = (props: any) => {
  const wizardStepIndex = useCurrentStepIndex() ?? '';
  const { send, state } = useForm(wizardStepIndex);
  const { api, name } = useContext(ComparatorContext);
  const isCbMember = useField('*.is_cb_member');
  const isMember = useField('*.isMember');
  let canSubmit = true;

  if (
    (name.startsWith('energy') || name.startsWith('car')) &&
    isCbMember?.value === 'ja' &&
    isMember?.value === 0
  ) {
    canSubmit = false;
  }

  if (!send || !state) return null;
  const onClick = () => {
    if (props.registerInPeregrineEvent) {
      const allFields = [
        ...(state.context.externalFields || []),
        ...state.context.fields,
      ];
      try {
        const graphApi =
          api as GraphComparisonApiService<GraphLegacyApiService>;
        const p1 = graphApi.getPeregrineUserHash(allFields);
        const p2 = graphApi.getPeregrinePartnerHash(allFields);
        const p3 = graphApi.getPeregrineActiveExperiments(allFields);

        Promise.all([p1, p2, p3]).then(
          ([userHash, partnerHash, activeExperiments]) => {
            const eventData = props.registerInPeregrineEvent(
              allFields,
              userHash,
              partnerHash,
              activeExperiments,
            );
            graphApi.sendPeregrineEvent(eventData);
          },
        );
      } catch (e) {
        console.log(e);
      }
    }
    if (canSubmit) {
      send('SUBMIT');
      if (state.value === 'completed') {
        scrollToTop();
      }
    }
  };

  return (
    <Button onClick={onClick} {...props}>
      {props.children}
    </Button>
  );
};
